import * as React from "react";
import type { SVGProps } from "react";
const SvgNotificationBell = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24" {...props}
  >
    <path
      stroke="#323232"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M13.6 20h-3.2"
    />
    <path
      stroke="#323232"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M17 10.032V10v0a5 5 0 0 0-5-5v0a5 5 0 0 0-5 5v2.504a.86.86 0 0 1-.472.764l-.503.251A1.86 1.86 0 0 0 5 15.178v0c0 1.024.83 1.854 1.854 1.854h10.292c1.024 0 1.854-.83 1.854-1.854v0c0-.702-.397-1.344-1.025-1.658l-.503-.251a.86.86 0 0 1-.472-.765z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgNotificationBell;
